import * as React from "react"
import type { SVGProps } from "react"
const SvgLongArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 7.99v11.15a1 1 0 0 1-.29.71 1 1 0 0 1-.71.3 1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7V7.98l-2.85 2.85q-.3.3-.7.29a1 1 0 0 1-1.01-1 1 1 0 0 1 .29-.72l4.57-4.57q.14-.15.33-.21a1 1 0 0 1 .74 0 1 1 0 0 1 .33.2l4.57 4.58q.3.3.29.72a1 1 0 0 1-1.01 1 1 1 0 0 1-.7-.29z" />
  </svg>
)
export default SvgLongArrowUp
